import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=9885c570&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"
import style0 from "./Index.vue?vue&type=style&index=0&id=9885c570&prod&scoped=true&lang=css"
import style1 from "./Index.vue?vue&type=style&index=1&id=9885c570&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9885c570",
  null
  
)

export default component.exports